var CircleSliderHelper = /** @class */ (function () {
    function CircleSliderHelper(stepsArray, initialValue) {
        var _this = this;
        this.setCurrentStepIndexFromArray = function (value) {
            for (var i = 0; i < _this.countSteps; i++) {
                if (value <= _this.stepsArray[i]) {
                    _this.stepIndex = i;
                    return true;
                }
            }
            _this.stepIndex = _this.countSteps;
            return false;
        };
        this.stepsArray = stepsArray;
        this.countSteps = this.stepsArray.length - 1;
        this.stepIndex = 0;
        this.setCurrentStepIndexFromArray(initialValue);
    }
    CircleSliderHelper.prototype.getEpsilon = function () {
        var epsilon = 1.0;
        while (1.0 + 0.5 * epsilon !== 1.0) {
            epsilon *= 0.5;
        }
        return epsilon;
    };
    CircleSliderHelper.prototype.getAngle = function () {
        var accuracy = 0.00001;
        var epsilon = Number.EPSILON || this.getEpsilon();
        return (Math.min(this.getAnglePoint() * this.stepIndex, 2 * Math.PI - epsilon) - accuracy);
    };
    CircleSliderHelper.prototype.getCurrentStep = function () {
        return this.stepsArray[this.stepIndex];
    };
    CircleSliderHelper.prototype.updateStepIndexFromValue = function (value) {
        var isSetValue = this.setCurrentStepIndexFromArray(value);
        if (isSetValue) {
            return;
        }
        this.stepIndex = this.countSteps;
    };
    CircleSliderHelper.prototype.updateStepIndexFromAngle = function (angle) {
        var stepIndex = Math.round(angle / this.getAnglePoint());
        if (stepIndex < this.countSteps) {
            this.stepIndex = stepIndex;
            return;
        }
        this.stepIndex = this.countSteps;
    };
    CircleSliderHelper.prototype.getAnglePoint = function () {
        return (Math.PI * 2) / this.countSteps;
    };
    return CircleSliderHelper;
}());
export { CircleSliderHelper };
//# sourceMappingURL=index.js.map